module.exports = "https://portperrypedals.ca/_res/img/our_cancer.7f092ed.png";